import { initializeApp } from "firebase/app"
import {
	type Auth,
	connectAuthEmulator,
	GoogleAuthProvider,
	getAuth,
} from "firebase/auth"

const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
	appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)
export const auth: Auth = getAuth(app)

// Test-only: route auth through the local Firebase Auth emulator when
// the build carries the flag (web-e2e authenticated suite, ZPL-99).
// Production builds never define it, so this branch is dead code there.
const authEmulatorHost = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST
if (authEmulatorHost) {
	connectAuthEmulator(auth, `http://${authEmulatorHost}`, {
		disableWarnings: true,
	})
}

export const googleProvider = new GoogleAuthProvider()
